import { applyMiddleware, compose, createStore } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import { redirect } from 'redux-first-router';
import createSagaMiddleware from 'redux-saga';
import queryString from 'query-string';
import thunk from 'redux-thunk';
import { find } from 'lodash';
import { ACTION_TYPES as PLAYOUT_ACTION_TYPES } from '../state/modules/app/playout/actions';

// imports for router
import { connectRoutes } from 'redux-first-router';
import routesMap from '../routesMap';

// redux sagas, reducers, actions
import sagas from './sagas';
import composeReducers from './rootReducer';
import { boot } from 'modules/app';

const {
  reducer: routerReducer,
  middleware: routerMiddleware,
  enhancer: routerEnhancer,
  initialDispatch
} = connectRoutes(routesMap, {
  querySerializer: queryString,
  initialDispatch: false,
  onBeforeChange: (dispatch, getState, { action }) => {
    const routeDefinition = routesMap[action.type];

    if (routeDefinition && routeDefinition.redirects) {
      const matchedRedirect = find(
        routeDefinition.redirects,
        ({ test }) => !!test(getState, action)
      );

      matchedRedirect && dispatch(redirect(matchedRedirect.to));
    }
  }
});

const sagaMiddleware = createSagaMiddleware();

let middlewares = [routerMiddleware, apiMiddleware, sagaMiddleware, thunk];

// const isDev = process.env.NODE_ENV === 'development';
// if (isDev) {
//   const { createLogger } = require(`redux-logger`);

//   middlewares.push(
//     createLogger({
//       collapsed: true
//     })
//   );
// }

// how File objects are displayed in redux-devtools
const formatFileForDevtools = file =>
  `<File name="${file.name}" size=${file.size} type="${file.type}" />`;

// display File object payloads
const actionSanitizer = action => {
  if (Object.values(PLAYOUT_ACTION_TYPES).includes(action.type)) {
    return {
      ...action,
      payload: depthFirst(
        action.payload,
        val => (val instanceof File ? formatFileForDevtools(val) : val)
      )
    };
  }
  return action;
};

// traverse the whole state object depth-first, apply `func` to leaves
const depthFirst = (obj, func) => {
  if (obj != null && obj.constructor === Array) {
    return obj.map(el => depthFirst(el, func));
  }

  if (obj != null && obj.constructor === Object) {
    const result = {};
    for (let key in obj) {
      const val = obj[key];
      result[key] = depthFirst(val, func);
    }
    return result;
  }

  return func(obj);
};

// return a copy of state with File objects formatted to strings
const stateSanitizer = state => {
  return {
    ...state,
    playout: depthFirst(
      state.playout, //currently, apply for playout data.
      val => (val instanceof File ? formatFileForDevtools(val) : val)
    )
  }
};

const composeMiddlewares = applyMiddleware(...middlewares);
const composeEnhancers = (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ actionSanitizer, stateSanitizer })) || compose;

export default function configureStore() {
  const store = createStore(
    composeReducers({ location: routerReducer }),
    composeEnhancers(routerEnhancer, composeMiddlewares)
  );

  sagaMiddleware.run(sagas);
  initialDispatch();
  store.dispatch(boot());
  window.store = store;

  return store;
}
